/**
 * 将 Temu bg.goods.attrs.get 结果转换为发品 Editor（SHEIN 布局）可解析的 attribute_infos 形态。
 *
 * SHEIN 约定（parseAttributeTemplate）：
 * - attribute_type 1 = 销售属性，3/4 = 货品属性，2 = 尺码测量
 * - attribute_label 1 = 主销售（颜色）
 * - attribute_status 3 = 必填
 * - attribute_mode 0 手输 / 1 多选 / 3 单选 / 4 成分比例
 */

function mapControlTypeToMode(controlType, chooseMaxNum) {
  const ct = Number(controlType);
  // INPUT
  if (ct === 0) return 0;
  // PROPERTY_CHOOSE_AND_INPUT / 成分类
  if (ct === 16) return 4;
  // CHOOSE / INPUT_CHOOSE
  if (ct === 1 || ct === 3) {
    const max = Number(chooseMaxNum);
    if (Number.isFinite(max) && max > 1) return 1;
    return 3;
  }
  return 3;
}

/**
 * @param {object} attrsResult Temu attrs.get result
 * @param {{ catId?: string|number }} [opts]
 */
export function normalizeTemuAttrsToEditorShape(attrsResult, opts = {}) {
  if (!attrsResult || typeof attrsResult !== 'object') {
    return { data: [], inputMaxSpecNum: 0 };
  }
  // 已是 Editor 形态则透传
  if (Array.isArray(attrsResult.data) || Array.isArray(attrsResult.attribute_infos)) {
    return attrsResult;
  }
  const properties = Array.isArray(attrsResult.properties) ? attrsResult.properties : [];
  const catId = opts.catId ?? attrsResult.catId ?? '';
  const attribute_infos = properties.map((p) => {
    if (!p || typeof p !== 'object') return null;
    const templatePid = p.templatePid ?? p.template_pid;
    const pid = p.pid;
    const attributeId = templatePid ?? pid;
    if (attributeId == null) return null;
    const isSale = Boolean(p.isSale);
    const values = (Array.isArray(p.values) ? p.values : []).map((v) => ({
      attribute_value_id: v.vid ?? v.specId ?? v.id,
      attribute_value: v.value ?? v.specName ?? '',
      attribute_value_name: v.value ?? v.specName ?? '',
      attribute_value_en: v.lang2Value?.en || '',
      // 发品回写 Temu 字段
      temu_vid: v.vid,
      temu_spec_id: v.specId,
      temu_value_group_id: v.group?.id,
      temu_value_group_name: v.group?.name,
      // 父子属性：值级依赖（提交/下拉过滤用）
      parentVidList: Array.isArray(v.parentVidList)
        ? v.parentVidList
        : (Array.isArray(v.parent_vid_list) ? v.parent_vid_list : []),
    })).filter((v) => v.attribute_value_id != null && String(v.attribute_value || '').trim());

    return {
      attribute_id: attributeId,
      attribute_name: p.name || '',
      attribute_name_cn: p.name || '',
      attribute_name_en: p.lang2Name?.en || '',
      attribute_type: isSale ? 1 : 3,
      attribute_label: p.mainSale ? 1 : 0,
      attribute_status: p.required ? 3 : 0,
      attribute_mode: mapControlTypeToMode(p.controlType, p.chooseMaxNum),
      attribute_input_num: p.chooseMaxNum || p.inputMaxNum || 0,
      attribute_value_info_list: values,
      // 原始 Temu 属性，提交时组装 productPropertyReqs / productSpecPropertyReqs
      temu_prop: {
        templatePid,
        pid,
        refPid: p.refPid,
        name: p.name,
        isSale,
        mainSale: Boolean(p.mainSale),
        parentSpecId: p.parentSpecId,
        valueUnit: Array.isArray(p.valueUnit) ? (p.valueUnit[0] || '') : (p.valueUnit || ''),
        controlType: p.controlType,
        required: Boolean(p.required),
        showCondition: Array.isArray(p.showCondition)
          ? p.showCondition
          : (Array.isArray(p.show_condition) ? p.show_condition : undefined),
        parentTemplatePid: p.parentTemplatePid ?? p.parent_template_pid ?? null,
        templatePropertyValueParentList: p.templatePropertyValueParentList
          ?? p.template_property_value_parent_list,
      },
    };
  }).filter(Boolean);

  return {
    data: [{
      product_type_id: catId ? Number(catId) : undefined,
      attribute_infos,
    }],
    inputMaxSpecNum: Number(attrsResult.inputMaxSpecNum || 0),
    properties,
    _temuRaw: attrsResult,
  };
}
